// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"39527052","323":"f5cf2dee","453":"a75bae2b","511":"796f8415","665":"d6d4f094","728":"0b1b889b"}[chunkId] + ".chunk.js";
};